module.exports = __webpack_public_path__ + "fonts/feather_icon.5fad700a.eot";